module.exports = __webpack_public_path__ + "static/img/logo.56e20938.png";